<template>
  <div
    class="tab-pane fade active show"
    id="moto-process-violation"
    role="tabpanel"
    aria-labelledby="moto-process-violation-tab"
  >
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">請選擇</option>
            <option
              v-for="(list, index) in violationScenicArea"
              :key="index"
              :value="list.id"
            >
              {{ list.name }}
            </option>
          </select>
        </div>

        <!-- <div class="col-md-2">
          <label for="inputEmail4" class="form-label">違規類型</label>
          <select class="form-control" v-model.number="selectViolationType">
            <option value="-1">請選擇</option>
            <option v-for="(list, index) in violationTypeList" :key="index" :value="list.id">{{ list.description }}</option>
          </select>
        </div> -->

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="startTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="endTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-12 d-flex align-items-end col-12 row">
          <div class="row my-3 mb-md-2 col-md-auto col-12">
            <button
              type="button"
              class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1 col-3 col-md-auto mt-3 mt-sm-2"
              @click="queryElk"
              :disabled="isWaitResult"
            >
              <i class="fas fa-search"></i> 查詢
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm rounded-pill px-3 mx-1 col-3 col-md-auto mt-3 mt-sm-2"
              @click="queryCSV"
              :disabled="isWaitResult"
            >
              <i class="fas fa-share"></i> 匯出
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm rounded-pill px-3 mx-1 col-6 col-md-auto mt-3 mt-sm-2"
              @click="switchBatchEdit"
            >
              <i v-if="!batchStatus" class="fa fa-edit"></i>
              <i v-if="batchStatus" class="fas fa-times"></i>

              {{ batchStatus !== true ? "開啟" : "關閉" }}列印
              {{ isShortView !== true ? null : "多筆" }}違規單
            </button>
          </div>
          <div v-if="batchStatus" class="row col-md-auto col-12 mb-md-2">
            <button
              type="button"
              class="btn btn-info btn-sm rounded-pill px-3 mx-1 col-auto col-md-auto my-md-1 mb-2 mb-md-0"
              @click="getViolationPDF(selectData, 'basic')"
            >
              <i class="fa fa-pen"></i> 批次產生違規單 (簡易版)
            </button>
            <button
              type="button"
              class="btn btn-info btn-sm rounded-pill px-3 mx-1 col-auto col-md-auto my-md-1 mb-2 mb-md-0"
              @click="getViolationPDF(selectData, 'official')"
            >
              <i class="fa fa-pen"></i> 批次產生違規單 (關防版)
            </button>
          </div>
        </div>
      </form>

      <h1 style="margin-top: 0px">機車闖入查詢</h1>
      <p>
        車牌偵測說明：若影像內的車牌過於模糊或太小造成無法正常辨識，則顯示N/A。
      </p>
      <p>多筆違規單產生說明：批次產生違規單期間不得跨月</p>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">
              <table
                id="motoProcessTable"
                class="w3-table-all table table-striped"
              >
                <thead class="table-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">風景區</th>
                    <th scope="col">設備地點</th>
                    <th scope="col">時間</th>
                    <th scope="col">違規類型</th>
                    <th scope="col">車牌</th>
                    <th scope="col" v-show="isShortView">影像路徑</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in violationList"
                    :key="index"
                    :class="tableCenterStyle"
                  >
                    <td>
                      {{ index + 1 }}
                      <input
                        v-if="batchStatus"
                        type="checkbox"
                        v-model="selectedItems"
                        :value="item"
                      />
                    </td>
                    <td>{{ item.areaName }}</td>
                    <td>{{ item.publicPlaceName }}</td>
                    <td>{{ getTime(item) }}</td>
                    <td>
                      {{ UTILS.getViolationType(item.violationType) }}
                      <div v-if="isShortView">
                        <button
                          v-if="!batchStatus"
                          class="btn btn-primary btn-sm mb-1 mt-1 w-full"
                          @click="getViolationPDF(item, 'basic')"
                        >
                          違規事件通知單 (簡易)
                        </button>
                        <button
                          v-if="!batchStatus"
                          class="btn btn-primary btn-sm mb-1 mt-1 w-full"
                          @click="getViolationPDF(item, 'official')"
                        >
                          違規事件通知單 (關防)
                        </button>
                      </div>
                    </td>
                    <td>
                      <p class="mb-1">{{ getPlate(item.licensePlate) }}</p>
                      <div v-show="!isShortView">
                        <a
                          class="px-1 mx-1 mt-1"
                          :href="getElkImgHypeLink(item)"
                          target="_blank"
                        >
                          <div class="btn-search text-primary">
                            <i
                              class="fas fa-search"
                              @click="selectImg(item)"
                            ></i>
                            <!-- <p class="mb-0 btn-text">查看</p> -->
                          </div>
                        </a>
                      </div>
                      <button
                        class="btn btn-primary btn-sm mb-1"
                        data-bs-target="#editLicensePlate"
                        data-bs-toggle="modal"
                        @click="openEditModal(item)"
                      >
                        編輯
                      </button>
                    </td>
                    <td v-show="isShortView">
                      <!-- <a :href="getElkImgHypeLink(item)" target="_blank"> -->
                      <img
                        :src="getElkImgUrl(item)"
                        style="width: 100%"
                        @click="selectImg(item)"
                        class="cursor-pointer"
                      />
                      <!-- <img src="../../assets/img/test.jpg"  style="width:100%" @click="selectImg(item)">              -->
                      <!-- <button class="btn btn-primary" @click="selectImg(item)">查看</button> -->
                      <!-- </a> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- editLicensePlate Dialog Start-->

    <div
      class="modal fade"
      id="editLicensePlate"
      ref="editLicensePlate"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editLicensePlateTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title h5" id="editLicensePlateTitle">車牌編輯</h5>
            <button
              type="button"
              class="close close btn btn-secondary"
              data-bs-dismiss="modal"
              data-bs-target="#editLicensePlate"
              aria-label="Close"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body h6">
            <div class="row align-items-center">
              <div for="licensePateInput" class="col-2">車牌：</div>
              <input
                type="text"
                id="licensePateInput"
                class="form-control w-75"
                v-model="selectLicensePlate"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              data-bs-target="#editLicensePlate"
            >
              關閉
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="editLicensePlate()"
            >
              確認編輯
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- editLicensePlate Dialog End-->

    <!-- <dialog-modal ref="violationDetail" :showUpdateButton="false" :customUpdateButton="123" :modalSize="'xl'"
      :isImage="true" :isMarginAuto="true">
      <div class="object-detection-detail" v-if="ratioData != null"> -->
    <!-- using v-if for avoid to canvas is not defined -->
    <!-- <div class="border-bottom pb-1">
          <img :src='ratioData.image.src' :width="ratioData.image.width" :height="ratioData.image.height">
        </div>
      </div>
    </dialog-modal> -->
    <violation-dialog-modal
      ref="violationDetail"
      :showUpdateButton="false"
      :modalSize="'lg'"
      :modalTitle="'違規事件通知單（簡易版）'"
      :violationData="activeStatus === 'basic' ? selectData : null"
      @clearSelectedItems="clearSelectedItems"
    >
    </violation-dialog-modal>

    <violation-official-dialog-modal
      ref="violationOfficialDetail"
      :showUpdateButton="false"
      :modalSize="'lg'"
      :modalTitle="'違規事件通知單（關防版）'"
      :violationData="activeStatus === 'official' ? selectData : null"
    >
    </violation-official-dialog-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import DialogModal from "../../components/DialogModal.vue";
import violationDialogModal from "./violationDialogModal.vue";
import violationOfficialDialogModal from "./violationOfficialDialogModal.vue";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import exportCSV from "../../utils/exportCSV";
import { printOfficialViolationNotice } from "@/utils/exportViolationPDF";

export default {
  name: "Home",
  components: {
    DialogModal,
    violationDialogModal,
    violationOfficialDialogModal,
  },
  data() {
    return {
      UTILS: Utils,
      tableStyle: "table table-bordered  h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: 3,
      violationTypeList: CONST.VIOLATION_TYPE_ENUM,
      selectViolationType: 2, // 機車闖入為 type 2
      violationList: [],
      selectItem: null,
      ratioData: null,
      isWaitResult: false,
      viewPort: window.innerWidth,
      isShortView: true,
      maxSelectTime: Utils.getLastestTime(),

      selectData: [],
      selectedItems: [],
      batchStatus: false,
      activeStatus: "",
      selectLicensePlate: "",
      editItem: {},
    };
  },
  watch: {
    viewPort: {
      handler(newVal) {
        if (newVal < 500) {
          this.isShortView = false;
        } else {
          this.isShortView = true;
        }
      },
      immediate: true,
    },
    selectedItems: {
      handler(newVal) {
        console.log("selectedItems", newVal);
      },
    },
  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),

    violationScenicArea() {
      // return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.VIOLATION))
      return this.scenicAreaList.filter((s) => s.id === 3); //機車闖入景區僅顯示三仙台選項
    },
  },
  methods: {
    getElkImgHypeLink(item) {
      return Utils.transElkImgHyperLink(item.streamUrl);
      // return require("../../assets/img/test.jpg");
    },

    getElkImgUrl(item) {
      return Utils.transElkImgByNginx(item.streamUrl);
      // return require("../../assets/img/test.jpg") ;
      // return "https://imts.eastcoast-nsa.gov.tw/elkimage/api/Media/EventImage/fb2d5c7a-d520-4f35-8b9d-fac995f59fd3"
    },

    generateFileName(item) {
      return `${moment(item.dt).format("YYYY_MM_DD_HH_mm_ss")}_${
        item.licensePlate
      }.jpg`;
    },

    selectImg(item) {
      // console.log("item",item);
      //route to downloadImg.vue
      const queryParam = new URLSearchParams({
        id: item.eventID,
        area: item.areaName,
        dt: item.dt,
        publicPlace: item.publicPlaceName,
        licensePlate: item.licensePlate,
        streamUrl: item.streamUrl,
      }).toString();
      // this.$router.push(`/downloadImg?id=${item.eventID}`);
      const routePath = `${
        this.$router.resolve({ path: "/downloadImg" }).href
      }?${queryParam}`; // 檢查name是否正確
      window.open(routePath, "_blank");
    },

    imgZoom() {
      const img = new Image();
      img.src = this.getElkImgUrl(this.selectItem);
      // img.src = "../../src/assets/img/test.jpg"
      img.width = CONST.IMG_MAX_WIDTH;
      img.height = CONST.IMG_MAX_HEIGHT;

      if (
        img.width > CONST.IMG_MAX_WIDTH ||
        img.height > CONST.IMG_MAX_HEIGHT
      ) {
        this.ratioData = this.imgZoomIn(img);
      } else {
        this.ratioData = {
          image: img,
        };
      }
    },

    imgZoomIn(img) {
      let ratioWidth = 1;
      let ratioHeight = 1;
      const currentImgWidth = img.width;
      let currentImgHeight = img.height;
      let bRatioWidth = false;

      if (currentImgWidth > CONST.IMG_MAX_WIDTH) {
        ratioWidth = CONST.IMG_MAX_WIDTH / currentImgWidtho;
        currentImgHeight = currentImgHeight * ratioWidth;
        img.width = CONST.IMG_MAX_WIDTH;
        img.height = currentImgHeight;
        bRatioWidth = true;
      }

      if (currentImgHeight > CONST.IMG_MAX_HEIGHT) {
        ratioHeight = CONST.IMG_MAX_HEIGHT / currentImgHeight;
        img.height = CONST.IMG_MAX_HEIGHT;
        if (bRatioWidth) {
          img.width = CONST.IMG_MAX_WIDTH * ratioHeight;
        } else {
          img.width = currentImgWidth * ratioHeight;
        }
      }

      return {
        image: img,
      };
    },

    async queryCSV() {
      let violationList = "";
      if (this.selectScenicAreaId === -1) {
        alert("請選擇景區");
        return;
      }
      const result = await this.searchElk();

      if (result === true) {
        violationList = this.$store.getters["violation/getViolationData"];
      } else {
        violationList = [];
      }
      const csvContent = [["風景區", "設備名稱", "時間", "違規類型", "車牌"]];
      // const result =  this.searchElk();
      // console.log("result",result);
      // violationList = this.$store.getters['violation/getViolationData'];
      violationList.forEach((item) => {
        const row = [];
        row.push(item.areaName);
        row.push(item.publicPlaceName);
        row.push(this.getTime(item));
        row.push(Utils.getViolationType(item.violationType));
        row.push(this.getPlate(item.licensePlate));

        csvContent.push(row);
      });

      const fileName = `CSV_${moment(this.startTime).format(
        "YYYY/MM/DD HH:mm"
      )}_違規統計.csv`;
      exportCSV.genCSVFile(csvContent, fileName);
    },

    async queryElk() {
      const result = await this.searchElk();
      console.log("result", result);
      //若 searchElk() 完成 dispatch取值，才進行 getter取值
      if (result === true) {
        this.violationList = this.$store.getters["violation/getViolationData"];
        console.log("this.violationList", this.violationList);
      } else {
        this.violationList = [];
      }
      this.updateTable();
    },

    async searchElk() {
      if (
        Utils.isEmptyObject(this.startTime) ||
        Utils.isEmptyObject(this.endTime)
      ) {
        alert("請選擇起訖時間");
        return;
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert("結束時間不可以小於開始時間");
        return;
      }

      if (this.selectScenicAreaId === -1) {
        alert("請選擇景區");
        return;
      }

      // if (this.selectViolationType === -1) {
      //   alert('請選擇違規類型')
      //   return
      // }

      const condition = {
        startTime: moment(this.startTime).startOf("minute").format(),
        endTime: moment(this.endTime).startOf("minute").format(),
        scenicAreaId: this.selectScenicAreaId,
        type: this.selectViolationType,
      };

      await this.$store.dispatch("violation/getViolationData", condition);
      return true; //判斷是否滿足條件
    },

    getTime: function (item) {
      if (Utils.isEmptyObject(item.dt)) {
        return "-";
      }

      return moment(item.dt).format("YYYY/MM/DD HH:mm");
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime(); // 更新為當前時間
    },
    getPlate: function (item) {
      if (item === "N/A" || item === undefined) {
        return "N/A";
      }
      return item;
    },

    setActiveStatus(status) {
      //status 為字串
      this.activeStatus = status;
      // this.activeStatus = status
    },

    checkDateTime(data) {
      // 檢查 data裡面的每一個dt，是否在同一個年份與月份中
      if (data && data.length > 0) {
        const firstMoment = moment(data[0].dt);
        const baseYear = firstMoment.year();
        const baseMonth = firstMoment.month(); // month 回傳 0~11

        // 檢查所有 dt 是否與第一筆的年份與月份相同
        const allSame = data.every((item) => {
          const m = moment(item.dt);
          return m.year() === baseYear && m.month() === baseMonth;
        });
        if (!allSame) {
          return false;
        } else {
          return true;
        }
      }
    },
    getViolationPDF(item, type) {
      // 根據 batchStatus 決定選擇資料
      this.selectData = this.batchStatus ? this.selectedItems : [item];
      if (!this.checkDateTime(this.selectData)) {
        alert("批次產生違規單須月份相同");
        return;
      }
      this.setActiveStatus(type);
      // 根據不同 type 開啟對應 modal
      if (type === "basic") {
        this.$refs.violationDetail.openModal();
        // document.body.classList.add('no-scroll');
      } else if (type === "official") {
        this.$refs.violationOfficialDetail.openModal();
      } else {
        console.error("Unknow Type:", type);
      }
    },

    switchBatchEdit() {
      this.batchStatus = !this.batchStatus;
      this.selectedItems = []; //清空checkbox選擇
    },

    clearSelectedItems() {
      this.selectedItems = [];
    },

    openEditModal(item) {
      //開啟編輯車牌的modal
      this.editItem = { ...item };

      // console.log("item",item);
      // console.log("this.editLicensePlate",this.editLicensePlate);
    },

    async editLicensePlate() {
      if (this.selectLicensePlate === "") {
        alert("請輸入車牌");
        return;
      }
      let condition = {
        eventId: this.editItem.eventID,
        license: this.selectLicensePlate,
      };
      await this.$store.dispatch("violation/putLicensePlate", condition);
      //編輯車牌
      this.violationList = this.$store.getters["violation/getViolationData"];
      this.closeModal();
      this.updateTable();
    },

    closeModal() {
      $(this.$refs.editLicensePlate).modal("hide");
      $(".modal-backdrop").remove();
    },

    initTable: function () {
      this.table = $("#motoProcessTable").DataTable({
        autoWidth: false,
        columnDefs: [{ targets: 0, width: "25%" }],
        // aoColumns: [
        //   ...new Array($("#willProcessViolationTable th").length - 1),
        //   {
        //     bSortable: false,
        //   },
        // ],

        language: {
          url: "/json/dataTableZHTW.json",
        },
        pageLength: 25,
      });
    },
    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
  },
  async mounted() {
    this.updateTable();
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
    };
    window.addEventListener("resize", this.$_resizeEventHandler);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.$_resizeEventHandler);
  },
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

select:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

tbody > tr > td,
tr > th {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

/* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
}

/* table不超過div */

.disable-link {
  pointer-events: none;
}

.cursor-pointer {
  cursor: pointer;
}

.no-scroll {
  overflow: hidden;
}
</style>
